import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IDeepLinkProperties } from '../../../navigation/deep-link-properties.interface';
import { NavigationBuilder } from '../../../navigation/navigation.builder';
import { Notification } from '../../../notification-data/notification.model';
import { IRouter } from '../../../shared/interfaces/router.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import { TrackingDispatcher } from '../../../tracking/tracking.dispatcher';

@Component({
  selector: 'app-notifications-list-item',
  templateUrl: './notifications-list-item.component.html',
  styleUrls: ['./notifications-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsListItemComponent implements OnInit {
  @Input() notification: Notification;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output()
  onClickItem: EventEmitter<Notification> = new EventEmitter<Notification>();
  @Output()
  onDismissItem: EventEmitter<Notification> = new EventEmitter<Notification>();

  private _trackingObject: ITrackingObject;

  isNew: boolean;
  header: string;
  description: string;
  routeInfo: IRouter;

  constructor(
    private _navigationBuilder: NavigationBuilder,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder,
    private _trackingDispatcher: TrackingDispatcher
  ) {}

  ngOnInit() {
    const deepLinkProperties: IDeepLinkProperties = this._navigationBuilder.buildDeepLinkProperties(
      this.notification.actionUrl
    );

    this.isNew = this.notification.isNew();
    this.header = this.notification.mainText;
    this.description = this.notification.auxText;
    this.routeInfo = this._navigationBuilder.buildRouteFromDeepLinkProperties(
      deepLinkProperties
    );

    this._trackingObject = this._trackingObjectBuilder.buildNotification(
      this.notification.state,
      this.notification.actionUrl
    );
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    this._trackingDispatcher.trackEvent(
      this._trackingObject,
      this._trackingActionBuilder.buildTapped(this.trackingScreenName)
    );

    this.onClickItem.emit(this.notification);
  }

  onDismissClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    this._trackingDispatcher.trackEvent(
      this._trackingObject,
      this._trackingActionBuilder.buildDeleted(this.trackingScreenName)
    );

    this.onDismissItem.emit(this.notification);
  }
}
